import { ICreateReservationFormValues } from '../../containers/Form/CreateReservation/CreateReservation'
import mapValuesToRequest, { IRequestBody } from './mappers/mapValuesToRequest'
import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(
    calendarId: number,
    event: ICreateReservationFormValues,
  ) {
    const requestBody: IRequestBody = mapValuesToRequest(calendarId, event)
    const response = await api.fetch(`/api/v2/reservation/index`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    if (response.ok) {
      return await handleResponse(response)
    } else {
      throw new Error(response.status.toString())
    }
  }
}
